export interface NavigationAdminAccess {
  manageUsers: boolean;
  configure: boolean;
  operations?: boolean;
  auditLog?: boolean;
}

export const navigationMenu = (
  access: boolean | NavigationAdminAccess,
): string => {
  const adminAccess = typeof access === "boolean"
    ? { manageUsers: access, configure: access, operations: access, auditLog: access }
    : access;
  const showAdmin = adminAccess.manageUsers || adminAccess.configure || adminAccess.operations || adminAccess.auditLog;
  return `
  <div class="site-menu" data-site-menu>
    <button class="menu-trigger" type="button" aria-label="Menu" aria-expanded="false" aria-controls="site-menu-panel">
      <span class="menu-icon" aria-hidden="true"><i></i><i></i><i></i></span>
      <span>Menu</span>
    </button>
    <div class="menu-panel" id="site-menu-panel" hidden>
      <a href="/">Library</a>
      <a href="/profile">My Profile</a>
      ${showAdmin ? `
        <button class="admin-menu-trigger" type="button" aria-expanded="false" aria-controls="admin-menu-panel">
          <span>Admin</span><span aria-hidden="true">⌄</span>
        </button>
        <div class="admin-menu-panel" id="admin-menu-panel" hidden>
          ${adminAccess.manageUsers ? '<a href="/admin/users">Manage Users</a>' : ""}
          ${adminAccess.configure ? '<a href="/admin/configuration">Settings</a>' : ""}
          ${adminAccess.operations ? '<a href="/admin/operations">Operations</a>' : ""}
          ${adminAccess.auditLog ? '<a href="/admin/audit-log">Audit Log</a>' : ""}
        </div>` : ""}
      <a href="/about">About</a>
      <form method="post" action="/auth/logout">
        <button type="submit">Sign Out</button>
      </form>
    </div>
  </div>`;
};
